module.exports = __webpack_public_path__ + "img/sample-medicare-card-part-b.0865654.png";